import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/app/_components/ui/popover';
import { SidebarFooter } from '@/app/_components/ui/sidebar';
import { useAuth } from '@/app/_hooks/use-auth';
import { useToast } from '@/app/_hooks/use-toast';
import SidebarUserButton from './sidebar-user-button';
import SidebarUserActions from './sidebar-user-actions';

interface AppSidebarUserProfileProps {
  isCollapsed: boolean;
}

export function AppSidebarUserProfile({
  isCollapsed,
}: AppSidebarUserProfileProps) {
  const { toast } = useToast();
  const { user, logout } = useAuth();

  return (
    <SidebarFooter>
      <Popover>
        <PopoverTrigger asChild className="hover:cursor-pointer">
          <SidebarUserButton
            isCollapsed={isCollapsed}
            email={user?.user_info?.user_email}
            alias={user?.user_info?.user_alias}
            spend={user?.user_info?.spend}
          />
        </PopoverTrigger>
        <PopoverContent
          className="p-1 w-66 sm:w-56"
          side={isCollapsed ? 'right' : 'top'}
          align={isCollapsed ? 'center' : 'start'}
        >
          <SidebarUserActions
            onSignOut={() => {
              toast({
                title: 'Signed Out',
                description: 'You have been signed out successfully.',
              });
              logout();
            }}
          />
        </PopoverContent>
      </Popover>
    </SidebarFooter>
  );
}
